class SearchDrawer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // Teleport to body to fix stacking context issues (e.g. overlap with announcement bar)
    if (this.parentNode !== document.body) {
      const existing = document.body.querySelector(`#${this.id}`);
      // If there's an existing one (which shouldn't happen with unique ID but good for safety), remove it
      if (existing && existing !== this) {
        existing.remove();
      }
      document.body.appendChild(this);
      return;
    }
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#SearchDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderSearchIconAccessibility();
  }
  setHeaderSearchIconAccessibility() {
    const searchButtons = document.querySelectorAll('.header__icon--search');

    searchButtons.forEach(searchButton => {
      if (!searchButton) return;

      searchButton.setAttribute('role', 'button');
      searchButton.setAttribute('aria-haspopup', 'dialog');
      searchButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(searchButton);
      });
      searchButton.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(searchButton);
        }
      });
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner');
        const focusElement = this.querySelector('.search__input') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    if (!window.matchMedia('(min-width: 750px)').matches) {
      if (window.toggleScroll) {
        window.toggleScroll(false);
      } else {
        document.body.classList.add('overflow-hidden');
      }
    }
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    if (!window.matchMedia('(min-width: 750px)').matches) {
      if (window.toggleScroll) {
        window.toggleScroll(true);
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    }
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('search-drawer', SearchDrawer);